import type { MarketQuoteClient } from "./MarketQuote.client";
import { MarketQuote } from "./MarketQuote.model";

export class MockMarketQuoteClient implements MarketQuoteClient {
  private quoteMap: Map<string, MarketQuote> = new Map<string, MarketQuote>();

  private internalId: NodeJS.Timeout;

  constructor() {
    this.internalId = setInterval(() => {
      this.quoteMap.forEach((quote) => {
        quote.price.value = Math.max(0, Number(quote.price.value) + (Math.random() - 0.5) * 2).toString();
      });
    }, 1_000);
  }

  getMarketQuote(symbol: string): MarketQuote {
    let existingQuote = this.quoteMap.get(symbol);
    if (existingQuote) {
      return existingQuote!;
    }

    let marketQuote = new MarketQuote("Crypto", symbol);
    marketQuote.price.value = (Math.random() * 100).toString();
    this.quoteMap.set(symbol, marketQuote);
    return marketQuote;
  }

  destroy() {
    clearInterval(this.internalId);
    this.internalId = null!;
  }
}
